export default {
    "name": "Nachbestellung",
    "info_text": "Sparen Sie Zeit beim erneuten Bestellen! Unser Plugin ermöglicht es Kunden, mit nur einem Klick alle Artikel aus einer früheren Bestellung in den Warenkorb zu legen. Vereinfachen Sie den Einkaufsprozess und steigern Sie die Kundenzufriedenheit.",
    "orders_list": "Bestellübersicht",
    "order_page": "Bestelldetailseite"
}
